import { Link } from 'react-router-dom';
import { usePermissions } from '../../../platform/auth/permissions';
import { JourneyHelp } from '../../../components/ui/JourneyHelp';

export function FirstSteps() {
  const { can } = usePermissions();
  return (
    <JourneyHelp title="Por onde começar na Zeladoria?">
      <p>
        Esta visão reúne o que merece atenção na casa. Escolha uma tarefa; você não precisa
        preencher todos os módulos.
      </p>
      <ul>
        {can('community.people.read') && (
          <li>
            <Link to="/pessoas">Consultar pessoas da casa</Link>: busque pelo nome. O cadastro
            aparece apenas para quem tem permissão.
          </li>
        )}
        {can('calendar.events.read') && (
          <li>
            <Link to="/calendario">Consultar o calendário</Link>: selecione um dia para ver suas
            atividades.
          </li>
        )}
        <li>
          Se uma área não estiver disponível, procure a administração da casa para conferir seu
          acesso.
        </li>
      </ul>
      <p>
        Você pode fechar esta orientação e abri-la novamente. Ela não cria registros nem altera seu
        acesso.
      </p>
    </JourneyHelp>
  );
}
